import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["unitField"]

  toggleUnitField(event) {
    const requestType = event.target.value
    if (requestType === "unit") {
      this.unitFieldTarget.classList.remove("hidden")
    } else {
      this.unitFieldTarget.classList.add("hidden")
    }
  }
}
